// Helfer rund um die Changelog-/Neuigkeiten-Collections.
//
// Read-Pfade laufen über die normale PB-SDK gegen die Collection-Rules:
//   - "updates": jeder eingeloggte User darf lesen
//   - "update_bestaetigung": jeder sieht eigene, Admin sieht alle
//
// Schreibpfade sind absichtlich asymmetrisch:
//   - bestaetigeUpdate(): nur eigene Bestätigung anlegen
//   - createUpdate() / updateUpdate(): nur Admin (PB-Rule erzwingt das)

import { pb } from './pocketbase.js';

/** Liefert alle aktiven Updates, neuestes zuerst. */
export async function fetchAktiveUpdates() {
  return pb.collection('updates').getFullList({
    filter: 'aktiv = true',
    sort: '-veroeffentlicht_am,-created',
  });
}

/** Liefert ALLE Updates (auch deaktivierte) — für die Admin-Übersicht. */
export async function fetchAlleUpdates() {
  return pb.collection('updates').getFullList({
    sort: '-veroeffentlicht_am,-created',
  });
}

/**
 * Liefert die IDs der Updates, die der übergebene User bereits bestätigt hat.
 * Set für O(1)-Lookup.
 */
export async function fetchEigeneBestaetigteUpdateIds(userId) {
  if (!userId) return new Set();
  const list = await pb.collection('update_bestaetigung').getFullList({
    filter: `user = "${userId}"`,
    fields: 'update',
  });
  return new Set(list.map((b) => b.update));
}

/**
 * Liefert alle aktiven Updates, die der User noch NICHT bestätigt hat —
 * sortiert nach Veröffentlichung aufsteigend, damit beim Login das älteste
 * zuerst gezeigt wird.
 */
export async function fetchUnbestaetigteUpdates(userId) {
  const [updates, bestaetigteIds] = await Promise.all([
    fetchAktiveUpdates(),
    fetchEigeneBestaetigteUpdateIds(userId),
  ]);
  return updates
    .filter((u) => !bestaetigteIds.has(u.id))
    .sort((a, b) => (a.veroeffentlicht_am || '').localeCompare(b.veroeffentlicht_am || ''));
}

/** Markiert ein Update als bestätigt. PB verhindert per Unique-Index Duplikate. */
export async function bestaetigeUpdate(updateId, userId) {
  return pb.collection('update_bestaetigung').create({
    update: updateId,
    user: userId,
  });
}

/** Liefert alle Bestätigungen zu einem Update inkl. expand auf den User. */
export async function fetchBestaetigungenFuerUpdate(updateId) {
  return pb.collection('update_bestaetigung').getFullList({
    filter: `update = "${updateId}"`,
    expand: 'user',
    sort: '-bestaetigt_am',
  });
}
